import { render, staticRenderFns } from "./CarChartClient.vue?vue&type=template&id=354ef90c"
import script from "./CarChartClient.vue?vue&type=script&lang=js"
export * from "./CarChartClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports